
    <main class="body-content">

        <!-- Navigation Bar -->
        <nav class="navbar ms-navbar" style=" margin: unset;">
            <div class="ms-aside-toggler ms-toggler pl-0" data-target="#ms-side-nav" data-toggle="slideLeft"> <span class="ms-toggler-bar bg-primary"></span>
              <span class="ms-toggler-bar bg-primary"></span>
              <span class="ms-toggler-bar bg-primary"></span>
            </div>
            <div class="logo-sn logo-sm ms-d-block-sm">
              <a class="pl-0 ml-0 text-center navbar-brand mr-0" href="index.html"><img src="../../assets/Images/icon/Logo (2).png" alt="logo"> </a>
            </div>
            <ul class="ms-nav-list ms-inline mb-0" id="ms-nav-options">
              <li class="ms-nav-item ms-search-form pb-0 py-0">
                <form class="ms-form" method="post">
                  <div class="ms-form-group my-0 mb-0 has-icon fs-14">
                    <input type="search" class="ms-form-input" name="search" placeholder="Search here..." value=""> <i class="fa fa-search text-disabled"></i>
                  </div>
                </form>
              </li>
              <li class="ms-nav-item dropdown"> <a href="#" class="text-disabled ms-has-notification" id="mailDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-envelope FA-2X" style="color: black"></i></a> <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="mailDropdown">
                  <li class="dropdown-menu-header">
                    <h6 class="dropdown-header ms-inline m-0"><span class="text-disabled">Mail</span></h6><span class="badge badge-pill badge-success">3 New</span>
                  </li>
                  <li class="dropdown-divider"></li>
                  <li class="ms-scrollable ms-dropdown-list ps">
                    <a class="media p-2" href="#">
                      <div class="ms-chat-status ms-status-offline ms-chat-img mr-2 align-self-center">
                       
                      </div>
                      <div class="media-body"> <span>Hey man, looking forward to your new project.</span>
                        <p class="fs-10 my-1 text-disabled"><i class="material-icons">access_time</i> 30 seconds ago</p>
                      </div>
                    </a>
                    <a class="media p-2" href="#">
                      <div class="ms-chat-status ms-status-online ms-chat-img mr-2 align-self-center">
                      </div>
                      <div class="media-body"> <span>Dear John, I was told you bought Costic! Send me your feedback</span>
                        <p class="fs-10 my-1 text-disabled"><i class="material-icons">access_time</i> 28 minutes ago</p>
                      </div>
                    </a>
                    <a class="media p-2" href="#">
                      <div class="ms-chat-status ms-status-offline ms-chat-img mr-2 align-self-center">
                      </div>
                      <div class="media-body"> <span>How many people are we inviting to the dashboard?</span>
                        <p class="fs-10 my-1 text-disabled"><i class="material-icons">access_time</i> 6 hours ago</p>
                      </div>
                    </a>
                  <div class="ps__rail-x" style="left: 0px; bottom: 0px;"><div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div></div><div class="ps__rail-y" style="top: 0px; right: 0px;"><div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div></div></li>
                  <li class="dropdown-divider"></li>
                  <li class="dropdown-menu-footer text-center"> <a href="pages/apps/email.html">Go to Inbox</a>
                  </li>
                </ul>
              </li>
              <li class="ms-nav-item dropdown"> <a href="#" class="text-disabled ms-has-notification" id="notificationDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-bell FA-2X" style="color: black"></i></a>
                <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="notificationDropdown">
                  <li class="dropdown-menu-header">
                    <h6 class="dropdown-header ms-inline m-0"><span class="text-disabled">Notifications</span></h6><span class="badge badge-pill badge-info">4 New</span>
                  </li>
                  <li class="dropdown-divider"></li>
                  <li class="ms-scrollable ms-dropdown-list ps">
                    <a class="media p-2" href="#">
                      <div class="media-body"> <span>12 ways to improve your crypto dashboard</span>
                        <p class="fs-10 my-1 text-disabled"><i class="material-icons">access_time</i> 30 seconds ago</p>
                      </div>
                    </a>
                    <a class="media p-2" href="#">
                      <div class="media-body"> <span>You have newly registered users</span>
                        <p class="fs-10 my-1 text-disabled"><i class="material-icons">access_time</i> 45 minutes ago</p>
                      </div>
                    </a>
                    <a class="media p-2" href="#">
                      <div class="media-body"> <span>Your account was logged in from an unauthorized IP</span>
                        <p class="fs-10 my-1 text-disabled"><i class="material-icons">access_time</i> 2 hours ago</p>
                      </div>
                    </a>
                    <a class="media p-2" href="#">
                      <div class="media-body"> <span>An application form has been submitted</span>
                        <p class="fs-10 my-1 text-disabled"><i class="material-icons">access_time</i> 1 day ago</p>
                      </div>
                    </a>
                  <div class="ps__rail-x" style="left: 0px; bottom: 0px;"><div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div></div><div class="ps__rail-y" style="top: 0px; right: 0px;"><div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div></div></li>
                  <li class="dropdown-divider"></li>
                  <li class="dropdown-menu-footer text-center"> <a href="#">View all Notifications</a>
                  </li>
                </ul>
              </li>
      
              <li class="ms-nav-item ms-nav-user dropdown">
                <a href="#" id="userDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <img class="ms-user-img ms-img-round float-right" src="../../assets/Images/icon/avatar.jpg" alt="people">
                </a>
                <ul class="dropdown-menu dropdown-menu-right user-dropdown" aria-labelledby="userDropdown">
                  <li class="dropdown-menu-header">
                    <h6 class="dropdown-header ms-inline m-0"><span class="text-disabled">Welcome, Anny Farisha</span></h6>
                  </li>
                  <li class="dropdown-divider"></li>
                  <li class="ms-dropdown-list">
                    <a class="media fs-14 p-2" href="pages/prebuilt-pages/user-profile.html"> <span><i class="flaticon-user mr-2"></i> Profile</span>
                    </a>
                    <a class="media fs-14 p-2" href="pages/apps/email.html"> <span><i class="flaticon-mail mr-2"></i> Inbox</span> <span class="badge badge-pill badge-info">3</span>
                    </a>
                    <a class="media fs-14 p-2" href="pages/prebuilt-pages/user-profile.html"> <span><i class="flaticon-gear mr-2"></i> Account Settings</span>
                    </a>
                  </li>
                  <li class="dropdown-divider"></li>
                  <li class="dropdown-menu-footer">
                    <a class="media fs-14 p-2" href="pages/prebuilt-pages/lock-screen.html"> <span><i class="flaticon-security mr-2"></i> Lock</span>
                    </a>
                  </li>
                  <li class="dropdown-menu-footer">
                    <a class="media fs-14 p-2" href="pages/prebuilt-pages/default-login.html"> <span><i class="flaticon-shut-down mr-2"></i> Logout</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            <div class="ms-toggler ms-d-block-sm pr-0 ms-nav-toggler" data-toggle="slideDown" data-target="#ms-nav-options"> <span class="ms-toggler-bar bg-primary"></span>
              <span class="ms-toggler-bar bg-primary"></span>
              <span class="ms-toggler-bar bg-primary"></span>
            </div>
          </nav>

<div class="row page-titles ms-panel" style="margin-right: unset;  margin-left: unset;padding-top: 9px;">
             
            
  <div class="col-md-5 align-self-center">
    <h4 class="text-themecolor">Restaurents Working Hours </h4>
</div>
<div class="col-md-7 align-self-center text-right">
    <div class="d-flex justify-content-end align-items-center" *ngIf="Drop">
        <button type="button" class="btn btn-info d-none d-lg-block m-l-15" style="margin-bottom: 10px;" (click)="Show()"><i class="fa fa-plus-circle"></i> Add Hours</button>
    </div>
</div>
  <div *ngIf="!Drop" style="    margin-top: 20px;"  id="Menus">
<div class="col-md-12" id="Menus">
<div class="">
<button id="Menu" tabindex="92" class="accordion" style="display: block;">Restaurents Working Hours </button>
</div>


</div>
<div class="col-md-12" style="padding-top: 30px;padding-bottom: 30px;">
<div class="col-md-12">

<div class="col-md-3 ">
  <div class="form-group">
      <label class="control-label">Resturant</label>
   <select class="form-control"  [(ngModel)]="Res_Id">
       <option disabled selected value=0>Select Resturant</option>
       <option *ngFor="let res of ResArray" value={{res.restaurantId}}>{{res.name}}</option>

   </select>
</div>
</div>
<div class="col-md-3 ">
  <div class="form-group">
      <label class="control-label">Day</label>
   <select class="form-control"  [(ngModel)]="DayName">
       <option disabled selected value="">Select Day</option>
       <option  value="Sunday">Sunday</option>
       <option  value="Monday">Monday</option>
       <option  value="Tuesday">Tuesday</option>
       <option  value="Wednesday ">Wednesday </option>
       <option  value="Thursday ">Thursday </option>
       <option  value="Friday ">Friday </option>
       <option  value="Friday ">Saturday </option>
   </select>
</div>
</div>
</div>
<div class="col-md-12">

<div class="col-md-3 ">
<div class="form-group">
    <label class="control-label"> Start Time</label>
    <input placeholder="Start Time" aria-label="Start Time" [(ngModel)]="STime" [ngxTimepicker]="fullTime" [format]="24" class="form-control" >
    <ngx-material-timepicker #fullTime></ngx-material-timepicker>
</div>


</div>
<div class="col-md-3 ">
<div class="form-group">
  <label class="control-label" >End Time</label>
  <input placeholder="End Time" aria-label="End Time" [(ngModel)]="ETime" [ngxTimepicker]="Time" [format]="24" class="form-control" >
  <ngx-material-timepicker #Time></ngx-material-timepicker>
</div>
</div>
</div>

<div class="col-md-12" style="padding-bottom: 25px;">
<div class="col-md-6">
<div class="form-group">
  <label class="control-label">Description</label>
<input type="text" class="form-control" style="height: 50px;" [(ngModel)]="Description">
</div>
</div>
<div class="col-md-6">
<div class="col-md-3" style="padding-top: 39px;"  *ngIf="Activebutton">
  <input type="checkbox" checked (change)="ActiveCheckboxChangeHeaddr($event)"> Set As Active
</div>
<div class="col-md-3" style="padding-top: 39px;"   *ngIf="Activebutton1">
<input type="checkbox" (change)="ActiveCheckboxChangeHeaddr($event)"> Set As Active
</div>

<div class="col-md-3"  style="padding-top: 22px;" *ngIf="Saveshow">
  <button class="btn " style="background: green; color: white;border-radius: 4px;" (click)="Save()">SAVE</button>
</div>
<div class="col-md-3"  style="padding-top: 22px;" *ngIf="!Saveshow">
<button class="btn " style="background: green; color: white;border-radius: 4px;" (click)="Update()">Update</button>
</div>
<div class="col-md-3"  style="padding-top: 22px;">
  <button class="btn " style="background: blue; color: white;;border-radius: 4px" (click)="clear()">CLEAR</button>
</div>
</div>
</div>
<div class="col-md-12">
<span [hidden]="isShownError" style="color: red;">{{ErrorMsg}}</span>
<span [hidden]="isShownSuccess" style="color: green;">{{SuccessMsg}}</span>
</div>
</div>



</div>
</div>
<div class="ms-content-wrapper">
    <div class="row">

      <div class="col-md-12">

        <div class="ms-panel">
          <div class="ms-panel-body">
            <div class="table-responsive">
              <div id="data-table-5_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                  <div class="row"><div class="col-sm-12 col-md-6">
                      <div class="dataTables_length" id="data-table-5_length">
                        <label style="padding-right: 25px;">Working Hours</label>
                        <input type="text" placeholder="Search" matInput (keyup)="applyFilter($event.target.value)" style="border: unset;background:  #ececec;height: 37px;width: 76%;"> <i class="fa fa-search fa-2x" style="color:red;position: absolute;    left: 88%; top: 3px;"></i>
                    </div></div>
                    <div class="col-sm-12 col-md-6"><div id="data-table-5_filter" class="dataTables_filter" style="text-align: left;padding-top: 5px;">
                            
                      <button class="btn" style="background: blue;color: white;padding:unset;margin: unset; margin-left: 25px;" (click)="exportexcel()" >Export</button>
                      <label style="padding-left: 50px;">Show</label>
                      <label class="switch" style="margin-left: 10px;">
                          <input type="checkbox" checked (change)="ActiveCheckboxChange($event)">
                          <span class="slider round"></span>
                        </label>
                        </div>
                      </div>
                    </div>
                    <div class="mat-elevation-z8" style="box-shadow: unset;padding-top: 30px ;" #TABLE>
                      <table mat-table [dataSource]="dataSource" #table style="width: 100%;" matSort >
                       
                        <!-- Position Column -->
                        <ng-container matColumnDef="sno" >
                          <th mat-header-cell *matHeaderCellDef  style="color: white !important;"> S.NO </th>
                          <td mat-cell  *matCellDef="let item; let j = index"> {{(j +1)  + (myPaginator.pageIndex * myPaginator.pageSize) }} </td>
                        </ng-container>
                    
                        <!-- Name Column -->
                        <ng-container matColumnDef="name">
                          <th mat-header-cell *matHeaderCellDef  mat-sort-header style="color: white !important;"> Restaurant Name </th>
                          <td mat-cell *matCellDef="let element" (click)="HoursEdit(element.workingHourMasterId)"> {{element.name}} </td>
                        </ng-container>
                        <ng-container matColumnDef="day">
                          <th mat-header-cell *matHeaderCellDef  mat-sort-header style="color: white !important;"> Day </th>
                          <td mat-cell *matCellDef="let element" (click)="HoursEdit(element.workingHourMasterId)"> {{element.day}} </td>
                        </ng-container>
                        <!-- Weight Column -->
                        <ng-container matColumnDef="startTime" >
                          <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: white !important;">Starting Time </th>
                          <td mat-cell *matCellDef="let element"  (click)="HoursEdit(element.workingHourMasterId)"> {{element.startTime}} </td>
                        </ng-container>
                    
                        <!-- Symbol Column -->
                        <ng-container matColumnDef="endTime" >
                          <th mat-header-cell *matHeaderCellDef mat-sort-header  style="color: white !important;"> Ending Time </th>
                          <td mat-cell *matCellDef="let element"  (click)="HoursEdit(element.workingHourMasterId)">  {{element.endTime}} </td>
                        </ng-container>
                        <ng-container matColumnDef="description" >
                          <th mat-header-cell *matHeaderCellDef mat-sort-header  style="color: white !important;"> Description </th>
                          <td mat-cell *matCellDef="let element"  (click)="HoursEdit(element.workingHourMasterId)">  {{element.description}} </td>
                        </ng-container>
                        <ng-container matColumnDef="Status" >
                          <th mat-header-cell *matHeaderCellDef  style="color: white !important;text-align: center;"> Active </th>
                          <td mat-cell *matCellDef="let element"> 
                            <label class="switch" style="margin-left: 10px;">
                              <input type="checkbox" checked *ngIf="element.active=='Active' ? true :false">
                              <input type="checkbox"  *ngIf="element.active=='Active' ? false :true">
                              <span class="slider round"></span>
                            </label>
                         </td>
                        </ng-container>
                      
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                      </table>
                    
                      <mat-paginator #myPaginator [pageSizeOptions]="[5, 10,15, 20,30,40]" showFirstLastButtons></mat-paginator>
                    </div>
                                             
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
    </div>
      </main>
  
